/**
 * Mapeo de menu keys a vista claves
 * Permite verificar si un usuario tiene permiso para ver una opción del menú
 * 
 * Key del menú → Clave de vista (sin considerar módulo, se calcula dinámicamente)
 */
export const MENU_KEY_TO_VISTA_MAP = {
  // Configuration > General
  'configuracion_aplicacion': 'admin/configuracion_aplicacion',
  'certificados': 'admin/certificados',
  'empresas': 'admin/empresas',
  'users': 'admin/users',
  'roles': 'admin/roles',
  'configuracion_email': 'admin/configuracion_email',

  // Configuration > Nomina
  'configuracion_nomina': 'admin/configuracion_nomina',
  'parametros': 'admin/parametros',
  'tipo_concepto': 'admin/tipo_concepto',
  'tipo_saldo': 'admin/tipo_saldo',
  'concepto': 'admin/concepto',
  'concepto_acomulado': 'admin/concepto_acomulado',
  'periodos': 'admin/periodos',
  'calculos': 'admin/calculos',
  'variable_formula': 'admin/variable_formula',
  'formulas_globales': 'admin/formulas_globales',
  'funciones': 'admin/funciones',
  'definicion_polizas': 'admin/definicion_polizas',
  'definicion_formato_banco': 'admin/definicion_formato_banco',

  // Configuration > Recursos Humanos
  'compania': 'admin/compania',
  'registro-patronal': 'admin/registro-patronal',
  'areas-trabajo': 'admin/areas-trabajo',
  'tabuladores': 'admin/tabuladores',
  'rutas': 'admin/rutas',
  'integrados': 'admin/integrados',
  'niveles-organizacionales': 'admin/niveles-organizacionales',
  'niveles-organizacionales2': 'admin/niveles-organizacionales2',
  'niveles-organizacionales3': 'admin/niveles-organizacionales3',
  'niveles-organizacionales4': 'admin/niveles-organizacionales4',
  'niveles-organizacionales5': 'admin/niveles-organizacionales5',
  'motivos_baja': 'admin/motivos_baja',
  'tipos_liquidacion': 'admin/tipos_liquidacion',
  'horarios': 'admin/horarios',
  'supervisores': 'admin/supervisores',
  'motivos': 'admin/motivos',
  'tipos_ausencia': 'admin/tipos_ausencia',
  'tipo_incapacidad': 'admin/tipo_incapacidad',

  // Configuration > Recursos Asistencia
  'timeleave': 'admin/tiempo_personal',
  'timesheet': 'admin/timesheet',
  'estacion_chequeo': 'admin/estacion_chequeo',

  // Nomina > Empleado Nomina
  'historico_nomina_empleado': 'admin/historico_nomina_empleado',
  'acumulados_del_periodo': 'admin/acumulados_del_periodo',
  'timbrados_del_periodo': 'admin/timbrados_del_periodo',
  'nomina_cerrada': 'admin/nomina_cerrada',
  'correcion_acumulado_mensual': 'admin/correcion_acumulado_mensual',
  'correcion_acumulado_anual': 'admin/correcion_acumulado_anual',
  'generar_poliza': 'admin/generar_poliza',

  // Nomina > Captura Nomina
  'saldos-empleado': 'admin/saldos-empleado',
  'movimientos-company': 'admin/movimientos-company',
  'movimientos-empleado': 'admin/movimientos-empleado',
  'movimientos-dias-horas': 'admin/movimientos-dias-horas',

  // Nomina > Procesos
  'procesar_nomina': 'admin/procesar_nomina',
  'procesar_nomina_global': 'admin/procesar_nomina_global',
  'cierre_nomina': 'admin/cierre_nomina',
  'timbrar_nomina': 'admin/timbrar_nomina',
  'timbrar_periodo': 'admin/timbrar_periodo',
  'desafectar_nomina': 'admin/desafectar_nomina',
  'distribucion_contable': 'admin/distribucion_contable',
  'depuracion_isr': 'admin/depuracion_isr',
  'piramidacion': 'admin/piramidacion',
  'retroactivo': 'admin/retroactivo',

  // Nomina > Liquidacion
  'finiquitos': 'admin/finiquitos',
  'recibo_finiquito': 'admin/recibo_finiquito',

  // Nomina > Interfaces
  'distribucion_bancaria': 'admin/distribucion_bancaria',
  'envio_recibos_correo': 'admin/envio_recibos_correo',
  'importacion_saldos': 'admin/importacion_saldos',
  'importacion_acumulados': 'admin/importacion_acumulados',
  'importacion_nomina': 'admin/importacion_nomina',
  'importacion_formato_poliza': 'admin/importacion_formato_poliza',

  // Nomina > Calculos Anuales
  'calculo_aguinaldo': 'admin/calculo_aguinaldo',
  'aplicacion_aguinaldo': 'admin/aplicacion_aguinaldo',
  'calculo_ptu_compania': 'admin/calculo_ptu_compania',
  'calculo_ptu_global': 'admin/calculo_ptu_global',
  'aplicacion_ptu': 'admin/aplicacion_ptu',
  'reparto_ahorro': 'admin/reparto_ahorro',
  'aplicacion_ahorro': 'admin/aplicacion_ahorro',
  'inicializacion_ahorro': 'admin/inicializacion_ahorro',
  'comparativo_anual_isr': 'admin/comparativo_anual_isr',
  'aplicar_diferencias_isr_anual': 'admin/aplicar_diferencias_isr_anual',

  // Nomina > Reportes
  'resumen_nomina_pdf': 'admin/resumen_nomina_pdf',
  'constancia_retenciones_isr': 'admin/constancia_retenciones_isr',
  'listado_de_nomina': 'admin/listado_de_nomina',
  'listado_de_finiquitos': 'admin/listado_de_finiquitos',
  'distribucion_efectivo': 'admin/distribucion_efectivo',

  // RRH > Captura
  'empleados': 'admin/empleados',
  'credito_infonavit': 'admin/credito_infonavit',
  'credito_fonacot': 'admin/credito_fonacot',
  'incapacidad_empleado': 'admin/incapacidad_empleado',

  // RRH > IMSS > SUA
  'sua_datos_afiltrados': 'admin/sua_datos_afiltrados',
  'sua_reingresos': 'admin/sua_reingresos',
  'sua_movimientos': 'admin/sua_movimientos',
  'sua_incapacidades': 'admin/sua_incapacidades',
  'sua_credito_infonavit': 'admin/sua_credito_infonavit',

  // RRH > IMSS > IDSE
  'idse_reingresos': 'admin/idse_reingresos',
  'idse_bajas': 'admin/idse_bajas',
  'idse_cambios_salario': 'admin/idse_cambios_salario',

  // RRH > Interfaces
  'importacion_incapacidades': 'admin/importacion_incapacidades',
  'importacion_creditos_infonavit': 'admin/importacion_creditos_infonavit',
  'importacion_creditos_fonacot': 'admin/importacion_creditos_fonacot',

  // RRH > Procesos
  'calculo_integrados': 'admin/calculo_integrados',
  'calculo_variable': 'admin/calculo_variable',

  // RRH > Reportes
  'kardex_empledo': 'admin/kardex_empledo',
  'ausentismo': 'admin/ausentismo',

  // Asistencia Configuración
  'dias_festivos': 'admin/dias_festivos',

  // Diseño de Asistencia
  'rol_turno': 'admin/rol_turno',
  'autorizaciones_por_empleado': 'admin/autorizaciones_por_empleado',
  'autorizaciones_globales': 'admin/autorizaciones_globales',
  'chequeo_entradas': 'admin/chequeo_entradas',
  'generacion_checadas': 'admin/generacion_checadas',
  'borrar_checadas': 'admin/borrar_checadas',
  'chequeo_dia': 'admin/chequeo_dia',
  'configuracion_checadas': 'admin/configuracion_checadas',
  'recibo_prenomina': 'admin/recibo_prenomina',
  'prenomina_periodo': 'admin/prenomina_periodo',
  'reporte_tiempo_extra': 'admin/reporte_tiempo_extra',
  'reporte_tiempo_ordinario': 'admin/reporte_tiempo_ordinario',
  'procesar_pre_nomina': 'admin/procesar_pre_nomina',
  'procesar_pre_nomina_global': 'admin/procesar_pre_nomina_global',
  'cierre_pre_nomina': 'admin/cierre_pre_nomina',
  'desafectar_pre_nomina': 'admin/desafectar_pre_nomina',

};

const ROUTE_PREFIXES = [
  'admin',
  'configuracion',
  'nomina',
  'recursos_humanos',
  'asistencia',
  'app',
];

const ROUTE_PREFERENCE = [
  'configuracion',
  'nomina',
  'recursos_humanos',
  'asistencia',
  'app',
  'admin',
];

function buildCandidates(mappedOrKey) {
  const rawValues = Array.isArray(mappedOrKey) ? mappedOrKey : [mappedOrKey];
  const candidates = new Set();

  rawValues
    .filter(Boolean)
    .map((value) => String(value).toLowerCase())
    .forEach((value) => {
      candidates.add(value);

      // Legacy mapping admin/<leaf> -> all known top-level modules
      if (value.startsWith('admin/')) {
        const leaf = value.slice('admin/'.length);
        ROUTE_PREFIXES.forEach((prefix) => candidates.add(`${prefix}/${leaf}`));
        candidates.add(leaf);
      } else if (!value.includes('/')) {
        // Bare key (ej. users) -> try module/key forms
        ROUTE_PREFIXES.forEach((prefix) => candidates.add(`${prefix}/${value}`));
      }
    });

  return Array.from(candidates);
}

function hasPermissionForKey(itemKey, visibleSet, visibleList) {
  if (String(itemKey || '').toLowerCase() === 'home') {
    return true;
  }

  const mapped = MENU_KEY_TO_VISTA_MAP[itemKey] || itemKey;
  const candidates = buildCandidates(mapped);

  return candidates.some((candidate) => {
    if (visibleSet.has(candidate)) {
      return true;
    }

    // Fallback por sufijo para rutas parametrizadas o variantes de módulo.
    if (!candidate.includes('/')) {
      return visibleList.some((vista) => vista.endsWith(`/${candidate}`));
    }

    return false;
  });
}

export function resolveMenuPathForKey(itemKey, visibleVistas) {
  const key = String(itemKey || '').toLowerCase();
  if (!key) {
    return null;
  }

  if (key === 'home') {
    return '/home';
  }

  const visibleSet = new Set(
    Array.from(visibleVistas || []).map((vista) => String(vista).toLowerCase())
  );

  const mapped = MENU_KEY_TO_VISTA_MAP[key] || key;
  const candidates = buildCandidates(mapped);

  const present = candidates.filter((candidate) => visibleSet.has(candidate));
  if (!present.length) {
    return null;
  }

  present.sort((a, b) => {
    const aPrefix = a.includes('/') ? a.split('/')[0] : '';
    const bPrefix = b.includes('/') ? b.split('/')[0] : '';
    const ai = ROUTE_PREFERENCE.indexOf(aPrefix);
    const bi = ROUTE_PREFERENCE.indexOf(bPrefix);
    const av = ai === -1 ? 999 : ai;
    const bv = bi === -1 ? 999 : bi;
    if (av !== bv) return av - bv;
    return a.length - b.length;
  });

  return `/${present[0]}`;
}

/**
 * Filtra recursivamente un array de items del menú basado en vistas visibles.
 * Si un item tiene 'key' que mapea a una vista, solo se incluye si el usuario 
 * tiene permiso. Si es un grupo (tiene 'children'), se filtra recursivamente.
 * 
 * @param {Array} items - Array de items del menú
 * @param {Set<string>} visibleVistas - Set de claves de vistas visibles para el rol
 * @returns {Array} Items del menú filtrados
 */
export function filterMenuByPermissions(items, visibleVistas) {
  if (!items || !visibleVistas) return items;

  const visibleSet = new Set(
    Array.from(visibleVistas || []).map((vista) => String(vista).toLowerCase())
  );
  const visibleList = Array.from(visibleSet);

  return (items || []).filter((item) => {
    // Si es hoja de menú con key, validar permisos con compatibilidad de rutas.
    if (item.key && (!item.children || !Array.isArray(item.children))) {
      if (!hasPermissionForKey(item.key, visibleSet, visibleList)) {
        return false;
      }
    }

    // Si tiene children, filtrar recursivamente
    if (item.children && Array.isArray(item.children)) {
      const filteredChildren = filterMenuByPermissions(item.children, visibleVistas);
      // Si no quedan children después de filtrar, excluir el grupo
      if (filteredChildren.length === 0) {
        return false;
      }
      item.children = filteredChildren;
    }

    return true;
  });
}

